import { render } from "./CheckoutPage.vue?vue&type=template&id=32e9f4c2&ts=true"
import script from "./CheckoutPage.vue?vue&type=script&lang=ts"
export * from "./CheckoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__